import { render, staticRenderFns } from "./CampaignInformationVSelectDedicatedNumber.vue?vue&type=template&id=c8b35ed6&scoped=true&"
import script from "./CampaignInformationVSelectDedicatedNumber.vue?vue&type=script&lang=js&"
export * from "./CampaignInformationVSelectDedicatedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b35ed6",
  null
  
)

export default component.exports